module.exports = __webpack_public_path__ + "img/logo.36efb565.png";